import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { UnionPayStackRoutes, UnionPayStackScreenProps } from '@/features/bill-payment/screens/union-pay/type';
import { AddNewAccountWebScreen } from '@/features/bill-payment/screens/union-pay/AddNewAccountWeb.screen';
import { AddNewAccountNativeScreen } from '@/features/bill-payment/screens/union-pay/AddNewAccountNative.screen';

export interface AddNewAccountProps {}

export const AddNewAccountScreen: React.FC<UnionPayStackScreenProps<UnionPayStackRoutes.AddNewAccount>> = ({ navigation, route }) => {
  const layout = useContext(LayoutContext);
  const {
    onLayout,
    onAccountSubmit,
    transferPeerCountFlag = true,
    onBack,
    wallet,
    calcFee,
    onChangeView,
    unionType,
    refresh,
    navigationNavigate,
    navigationScreen
  } = route.params;

  if (layout.isMobile) {
    return (
      <AddNewAccountNativeScreen
        onAccountSubmit={onAccountSubmit}
        transferPeerCountFlag={transferPeerCountFlag}
        onBack={onBack}
        wallet={wallet}
        calcFee={calcFee}
        unionType={unionType}
        refresh={refresh}
        navigationNavigate={navigationNavigate}
        navigationScreen={navigationScreen}
      />
    );
  }
  return (
    <AddNewAccountWebScreen
      onLayout={onLayout}
      onAccountSubmit={onAccountSubmit}
      transferPeerCountFlag={transferPeerCountFlag}
      onBack={onBack}
      wallet={wallet}
      calcFee={calcFee}
      onChangeView={onChangeView}
      unionType={unionType}
      refresh={refresh}
      navigationNavigate={navigationNavigate}
      navigationScreen={navigationScreen}
    />
  );
};
